import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { ItemIcon } from "@similarweb/ui-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const VersusWrapper = styled(FlexRow)`
    align-items: center;
    gap: 8px;
`;

export const MainDomainWrapper = styled(FlexRow)`
    align-items: center;
    gap: 8px;
`;

export const MainDomainText = styled.span`
    ${setFontVariant("body2", carbon[300])};
    max-width: 20ch;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const VersusLabel = styled.span`
    text-transform: lowercase;
    ${setFontVariant("body2", carbon[300])};
`;

export const ItemIconChainContainer = styled.div`
    position: relative;
    cursor: pointer;

    & div {
        color: ${carbon[250]};
    }

    &:hover {
        .ItemIcon {
            background-color: ${carbon[25]};
        }
    }
`;

const TooltipTitle = styled.div<{ paddingTop?: string }>`
    ${setFontVariant("captionTitle", carbon[250])};
    padding-top: ${({ paddingTop }) => paddingTop};
    margin-bottom: 8px;
    line-height: 16px;
`;

const PopupSiteText = styled.div`
    ${setFontVariant("input2", carbon[500])};
    margin-bottom: 8px;
    line-height: 16px;
    width: 168px;
    overflow: hidden;
    text-overflow: ellipsis;

    &:last-child {
        margin-bottom: 0;
    }
`;

const StyledItemIcon = styled(ItemIcon)`
    width: 24px;
    height: 24px;
    flex-shrink: 1;
`;
